import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getVodList, postClickInteraction } from "../../api/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHistory } from "react-router";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { isAndroid, isIOS } from "../../utils/os";
import showcaseButton from "./../../assets/images/showcase/Showcase_Button.png";
import showcaseEmpty from "../../assets/images/showcase/Showcase_Empty.png";
import "./style.scss";
import { androidApp, iosApp } from "../../static/config";
import androidDownloadImg from "../../assets/images/download/Google_Download.png";
import iosDownloadImg from "../../assets/images/download/IOS_Download.png";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true
};

const Banner = ({ bannerId }) => {
  const [items, setItems] = useState([]);
  const history = useHistory();

  const getBannerItems = async (id) => {
    const { data } = await getVodList(id);
    if (data?.items?.length) {
      setItems(data.items);
    }
  };

  const postClick = async (iKey) => {
    const { data } = await postClickInteraction(iKey);
  };

  const renderedItems = items.map((item) => {
    return (
      <div
        key={item.id}
        onClick={() => {
          postClick(item?.iKey);
          history.push(`/voddetail/${item.callToAction.objectId}`);
        }}
      >
        <LazyLoadImage
          src={item.image}
          style={{ width: "100%", height: "auto" }}
          alt="banner"
        />
      </div>
    );
  });

  const renderShowcase = () => {
    return (
      <div>
        {isAndroid || isIOS ? (
          <a
            href={isAndroid ? androidApp : iosApp}
            target="_blank"
            rel="noreferrer"
            className="showcase__mobile__link"
          >
            <img src={showcaseButton} alt="download app" />
          </a>
        ) : (
          <div className="div">
            <img src={showcaseEmpty} alt="download app" />
            <div className="showcase__desktop__download__container">
              <a
                href={androidApp}
                target="_blank"
                rel="noreferrer"
                className="showcase__desktop__android__link"
              >
                <img src={androidDownloadImg} alt="download android" />
              </a>
              <a
                href={iosApp}
                target="_blank"
                rel="noreferrer"
                className="showcase__desktop__ios__link"
              >
                <img src={iosDownloadImg} alt="download ios" />
              </a>
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (bannerId) {
      getBannerItems(bannerId);
    }
  }, [bannerId]);

  return (
    <div className="banner-wrapper">
      <div className="banner-container">
        <div key={bannerId}>
          <Slider {...settings}>{renderedItems}</Slider>
        </div>
      </div>
      <div className="showcase-container">{renderShowcase()}</div>
    </div>
  );
};

export default Banner;
